import AddBoxIcon from "@mui/icons-material/AddBox";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { GradationButton } from "../../utils/gradationButton";

interface BrowsingDialogsProps {
  openDeleteDialog: boolean;
  upgradeDialog: boolean;
  handleCloseDialog: () => void;
  handleConfirmDelete: () => void;
  handleUpgrade: () => void;
  handleCreateNewChat: () => void;
}

/**
 * ブラウジングダイアログコンポーネント
 * チャット作成時の上限アラートや無料ユーザー向けアップグレードダイアログを提供
 */
const BrowsingDialogs: React.FC<BrowsingDialogsProps> = ({
  openDeleteDialog,
  upgradeDialog,
  handleCloseDialog,
  handleConfirmDelete,
  handleUpgrade,
  handleCreateNewChat,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t("browsing.maxChatLimitTitle")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{t("browsing.deleteOldChatDescription")}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            {t("common.cancel")}
          </Button>
          <Button onClick={handleConfirmDelete} color="primary" autoFocus disableElevation startIcon={<AddBoxIcon />}>
            {t("browsing.createNewChat")}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={upgradeDialog}
        onClose={handleCloseDialog}
        aria-labelledby="upgrade-dialog-title"
        aria-describedby="upgrade-dialog-description"
        maxWidth="md"
      >
        <DialogTitle id="upgrade-dialog-title">{t("browsing.maxChatLimitTitle")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="upgrade-dialog-description">{t("browsing.maxChatLimitDescription")}</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <GradationButton onClick={handleUpgrade} color="primary">
            {t("browsing.upgradeNow")}
          </GradationButton>
          <Box sx={{ flexGrow: 1 }} />
          <Button onClick={handleCloseDialog} color="primary" disableElevation>
            {t("common.cancel")}
          </Button>
          <Button onClick={handleCreateNewChat} color="primary" autoFocus disableElevation startIcon={<AddBoxIcon />}>
            {t("browsing.createNewChat")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BrowsingDialogs;
